// @ts-ignore
import { Convertor } from 'encryption-utils';
import { v4 as uuid } from 'uuid';

// has to follow the base64url encoding, which changes 3 additional characters: +/=
const getCodeChallenge = (value: string) =>
    Convertor.bytesToBase64(Convertor.sha256(value)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');

export const getPkceInfo = () => {
    const codeVerifier = `${uuid()}-${uuid()}`;
    return {
        code_verifier: codeVerifier,
        code_challenge: getCodeChallenge(codeVerifier),
        code_challenge_method: 'S256',
    };
};
